define('models/Podio.Models.ConversationEvent',['require','lib/backbone/Backbone.PodioModel','lib/Podio.Time','models/Podio.Models.User','collections/Podio.Collections.Files','models/Podio.Models.Embed','models/Podio.Models.File'],function(require) {

  var PodioModel = require('lib/backbone/Backbone.PodioModel');
  var podioTime = require('lib/Podio.Time');

  return PodioModel.extend({

    has_one: function() {
      return {
        'created_by': require('models/Podio.Models.User')
      };
    },

    getFilesCollection: function() {
      var CollectionFiles = require('collections/Podio.Collections.Files'); // TODO: Move require to top when possible
      return new CollectionFiles(this.get('data').files);
    },

    getEmbed: function() {
      if (this.get('data').embed) {
        var ModelEmbed = require('models/Podio.Models.Embed'); // TODO: Move require to top when possible
        return new ModelEmbed(this.get('data').embed);
      }
    },

    getEmbedFile: function() {
      if (this.get('data').embed_file) {
        var ModelFile = require('models/Podio.Models.File'); // TODO: Move require to top when possible
        return new ModelFile(this.get('data').embed_file);
      }
    },

    createdOn: function() {
      return podioTime.localMomentFromString(this.get('created_on'));
    },

    destroy: function(freshMessage) {
      var apiURL = '/conversation/{0}/message/{1}/{2}'.format(this.collection.conversationId, this.get('data').id, freshMessage);
      return this.request('delete', apiURL).done(function() {
        this.trigger('destroy', this, this.collection);
      }.bind(this));
    },

  });

});

